/**
 * product-set-bundle.js — "sell as set" products. A picker of each variant (a piece) plus a
 * "Full set" tile. Picking a piece = a normal single-variant add; picking "Full set" adds one
 * line per variant (shared _build, merged by the cart-transform) so stock counts per variant,
 * and the merged line is discounted to joule.set_price. Data + UI: snippets/product-set-picker.liquid.
 */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    cents = Math.round(cents);
    function num(n, d, t, dec) {
      d = d == null ? 2 : d; t = t || ','; dec = dec || '.';
      var v = (n / 100).toFixed(d), p = v.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return d ? p[0] + dec + p[1] : p[0];
    }
    if (!format) return '€' + num(cents, 2);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_m, k) {
      switch (k) {
        case 'amount': return num(cents, 2, ',', '.');
        case 'amount_no_decimals': return num(cents, 0, ',');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ');
        default: return num(cents, 2);
      }
    });
  }
  function sectionOf(el) { return el.closest('[id^="product-"]') || el.closest('.shopify-section') || document; }

  function init(root) {
    var dataEl = root.querySelector('[data-set-data]');
    if (!dataEl) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data.variants || !data.variants.length) return;

    var section = sectionOf(root);
    var form = section.querySelector('form[action*="/cart/add"]');
    var atbPrice = section.querySelector('[data-atb-price]');
    var idInput = section.querySelector('[name="id"]') || section.querySelector('[data-variant-id]');
    var money = data.moneyFormat;

    // Replace the native variant picker — this picker drives everything. Also drop the quantity
    // stepper (a set / single piece is bought one at a time here).
    section.querySelectorAll('[data-option]').forEach(function (o) { o.style.display = 'none'; });
    var qtyBlock = section.querySelector('.product__qty');
    if (qtyBlock) qtyBlock.style.display = 'none';

    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-set-option]'));
    var sel = { full: true, variantId: null }; // default: full set

    function selectedPriceCents() {
      if (sel.full) return data.setPriceCents || 0;
      var v = data.variants.filter(function (x) { return String(x.variantId) === String(sel.variantId); })[0];
      return v ? v.price : 0;
    }
    function syncIdInput() {
      // The form needs a valid variant id; for a single piece it's the chosen one, for the full set
      // any valid variant (we intercept and bundle, so it isn't actually used).
      if (idInput) idInput.value = String(sel.full ? data.firstVariantId : sel.variantId);
    }

    var priceObs = atbPrice ? new MutationObserver(function () { applyTotal(); }) : null;
    function observePrice() { if (priceObs) priceObs.observe(atbPrice, { childList: true, characterData: true, subtree: true }); }
    function applyTotal() {
      if (!atbPrice) return;
      var html = ' · ' + formatMoney(selectedPriceCents(), money);
      if (priceObs) priceObs.disconnect();
      atbPrice.innerHTML = html;
      if (priceObs) { priceObs.takeRecords(); observePrice(); }
    }
    observePrice();

    function markActive() {
      tiles.forEach(function (t) {
        var on = t.getAttribute('data-set') === 'full' ? sel.full
          : (!sel.full && String(t.getAttribute('data-variant-id')) === String(sel.variantId));
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    tiles.forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.getAttribute('data-set') === 'full') sel = { full: true, variantId: null };
        else sel = { full: false, variantId: t.getAttribute('data-variant-id') };
        markActive(); syncIdInput(); applyTotal();
        // Jump the gallery to the picked piece's packshot (Full set → first image).
        var gallery = section.querySelector('[data-product-gallery]');
        var idx = sel.full ? 0 : parseInt(t.getAttribute('data-media-index'), 10);
        if (gallery && gallery.swiper && idx >= 0) {
          // Originals gallery loops, so map to the real slide.
          if (gallery.swiper.params.loop) gallery.swiper.slideToLoop(idx);
          else gallery.swiper.slideTo(idx);
        }
      });
    });

    markActive(); syncIdInput(); applyTotal();

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!sel.full) return; // single piece → let the native single-variant add proceed
        e.preventDefault();
        e.stopPropagation();
        var qtyEl = form.querySelector('[data-qty-input], [name="quantity"]');
        var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
        var build = 'pp_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

        var first = { _build: build, _piece_title: data.setTitle, _simple_bundle: '1' };
        if (data.parentVariantId) first._bundle_parent = 'gid://shopify/ProductVariant/' + data.parentVariantId;
        var img = data.setImage;
        if (img) { if (img.indexOf('//') === 0) img = 'https:' + img; img = img.replace(/[?&]width=\d+/, ''); first._snapshot_url = img; }
        if (data.setPriceCents > 0) first._set_total = (data.setPriceCents / 100).toFixed(2); // discount target, in major units

        var items = data.variants.map(function (v, i) {
          return { id: Number(v.variantId), quantity: qty, properties: i === 0 ? first : { _build: build } };
        });

        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;
        var api = window.PaoPaoCart;
        var p = (api && api.addItems) ? api.addItems(items) : Promise.reject();
        p.then(function () {}).catch(function () {}).then(function () { if (btn) btn.disabled = false; });
      });
    }
  }

  function boot() { document.querySelectorAll('[data-set-bundle]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
